import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationStore } from './permission/services/authentication.store';
import { Observable } from 'rxjs/Observable';
import { MenuStore } from './menus/service/menu.store';
import { PageScrollConfig } from 'ng2-page-scroll';
import { Angulartics2GoogleAnalytics } from 'angulartics2';
import { Router, NavigationEnd } from '@angular/router';
import { FlashMessagesComponent } from './shared/flash-messages/component/flash.messages.component';

@Component({
  selector: 'pioneer-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  @ViewChild(FlashMessagesComponent) flashMessageComponent: FlashMessagesComponent;

  userIsLoggedIn: Observable<boolean>;
  title: string;

  constructor(translate: TranslateService,
              authenticationStore: AuthenticationStore,
              menuStore: MenuStore,
              angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
              private router: Router) {
    // Configure the defaults and setup the translation service from ng-translate.
    translate.setDefaultLang('en-US');
    translate.use('en-US');

    // need to change duration, which otherwise would be 1250 milliseconds which feels very slow
    PageScrollConfig.defaultDuration = 0;

    this.userIsLoggedIn = authenticationStore.isLoggedIn();

    menuStore.pageTitle.subscribe(pageTitle => {
      // to remove the ExpressionChangedAfterItHasBeenCheckedError
      // https://github.com/angular/angular/issues/17572
      setTimeout(() => this.title = pageTitle, 0);
    });
  }

  ngOnInit() {
    this.resetPage();
  }

  /**
   * Checks to see if navigation was successful and resets the page
   * to an expected state.
   */
  resetPage() {
    this.router.events.subscribe((routerEvent) => {
      if (!(routerEvent instanceof NavigationEnd)) {
        return;
      }
      /**
       * Forces the app to scroll to the top of page when navigation is successful,
       * solving the issue where the user would change pages and stay in the middle
       * of the page.
       * See: https://stackoverflow.com/questions/39601026/angular-2-scroll-to-top-on-route-change
       */
      window.scrollTo(0, 0);

      /**
       * Resets any flash Messages that aren't set to be persistent.
       */
      this.flashMessageComponent.clearNonPersistentMessages();
    });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/app.component.ts